import { Button } from "components/ui/button/Button";
import "./terms-and-conditions.scss";
import { useSelector } from "react-redux";
import { getStepData } from "pages/application/question/questionSlice";
import { getCurrentUserApplicationId } from "features/authSlice";
import { useSetApplicationStepAnswerMutation } from "pages/application/applicationService";
import { useEffect, useState } from "react";
import { SkipButton } from "pages/application/question/Question";
import VerificationInfo from "components/verificationInfo/VerificationInfo";
import { TOSModal } from "./TOSModal";
import { VOA_StepCode } from "utilities/Constant";
import { trackOPTOptedVoa, trackOPTVOAStepLoaded } from "utilities/optimizely";

export default function Verification() {
  const stepData = useSelector(getStepData);
  const { nextStepActions: stepActions, stepCodeText } = stepData;
  const skipAction = stepData.skipAction;
  const [error, setError] = useState(false);
  const verificationType = stepCodeText == VOA_StepCode ? "VOA" : "VOI";

  const [updateApplication] = useSetApplicationStepAnswerMutation({
    fixedCacheKey: "updateApplication",
  });
  const applicationId = useSelector(getCurrentUserApplicationId);

  const handleSubmit = async (stepActionId: string) => {
    await updateApplication({
      id: applicationId,
      stepActionId,
    });
  };

  const [showAssetModal, setShowAssetModal] = useState<boolean>(false);
  const onAssetModalClose = () => {
    toggleAssetModal();
  };
  const toggleAssetModal = () => {
    if (!showAssetModal && verificationType == "VOA") {
      trackOPTOptedVoa();
    }
    setShowAssetModal(!showAssetModal);
  };

  const verificationText = verificationType == "VOA" ? "assets" : "income";

  useEffect(() => {
    if (verificationType == "VOA") {
      trackOPTVOAStepLoaded();
    }
  }, []);

  return (
    <div className="toc">
      {error && <div className="toc-error">AccountChek is unavailable at this time. Please enter your {verificationText} manually.</div>}
      <div className="toc-container1">
        <div className="toc-options">
          <div className="toc-popup">
            <TOSModal
              showAssetModal={showAssetModal}
              toggleAssetModal={toggleAssetModal}
              onAssetModalClose={onAssetModalClose}
              handleAssetModalError={(e) => setError(e)}
              verificationType={verificationType}
            />
          </div>
          <div className="toc-container">
            <div>
              <div className="toc-container__button">
                <Button
                  className={`toc-container__button--btn1 ${showAssetModal ? "active" : ""}`}
                  title={stepActions[0].label}
                  type="round"
                  variant="primary"
                  onClick={() => toggleAssetModal()}
                />
                <Button
                  className="toc-container__button--btn2"
                  title={stepActions[1].label}
                  type="round"
                  variant="outline-primary"
                  onClick={() => handleSubmit(stepActions[1].stepActionId)}
                />
              </div>
            </div>
          </div>
          {skipAction && <SkipButton skipAction={skipAction} />}
        </div>
        <VerificationInfo verificationType={verificationType} />
      </div>
    </div>
  );
}
